export const getAvatarInitials = (
  user:
    | {
        firstName?: string | null
        lastName?: string | null
      }
    | null
    | undefined
): string => {
  if (!user) return 'U'

  const firstInitial = user.firstName?.[0] ?? ''
  const lastInitial = user.lastName?.[0] ?? ''

  return firstInitial + lastInitial || 'U'
}
